module.exports = __webpack_public_path__ + "static/media/banner_1.f8bd7a9e.jpg";